// @ts-nocheck
import {
  SAVE_DASHBOARD_FILTERS_REQUEST,
  SAVE_DASHBOARD_FILTERS_SUCCESS,
  SAVE_DASHBOARD_FILTERS_FAILURE,
  GET_DASHBOARD_FILTERS_REQUEST,
  GET_DASHBOARD_FILTERS_SUCCESS,
  GET_DASHBOARD_FILTERS_FAILURE,
  DELETE_DASHBOARD_FILTERS_REQUEST,
  DELETE_DASHBOARD_FILTERS_SUCCESS,
  DELETE_DASHBOARD_FILTERS_FAILURE,
  UPDATE_DASHBOARD_FILTERS,
} from "../constants/dashboardFilters";
import {
  saveDashboardFilters,
  getDashboardFilters,
  deleteDashboardFilters,
} from "../../services/dashboardFiltersService";

/**
 * Save dashboard filters action
 * @param {string} dashboardId - Dashboard identifier
 * @param {object} filters - Filter object to save
 * @param {function} successCallback - Callback on success
 * @param {function} failureCallback - Callback on failure
 */
export const saveDashboardFiltersAction = ({
  dashboardId,
  filters,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      dispatch({ type: SAVE_DASHBOARD_FILTERS_REQUEST });

      const { response, error } = await saveDashboardFilters(
        dashboardId,
        filters
      );

      if (response?.data) {
        dispatch({
          type: SAVE_DASHBOARD_FILTERS_SUCCESS,
          payload: {
            dashboardId,
            data: response.data,
          },
        });
        successCallback?.(response.data);
      } else if (error) {
        dispatch({
          type: SAVE_DASHBOARD_FILTERS_FAILURE,
          payload: error?.message || "Failed to save filters",
        });
        failureCallback?.(error?.message || "Failed to save filters");
      } else {
        dispatch({
          type: SAVE_DASHBOARD_FILTERS_FAILURE,
          payload: "Unexpected response format",
        });
        failureCallback?.("Unexpected response format");
      }
    } catch (err) {
      console.error("❌ Exception in saveDashboardFiltersAction:", err);
      dispatch({
        type: SAVE_DASHBOARD_FILTERS_FAILURE,
        payload: err?.message || "An error occurred",
      });
      failureCallback?.(err?.message || "An error occurred");
    }
  };
};

/**
 * Get dashboard filters action
 * @param {string} dashboardId - Dashboard identifier
 * @param {function} successCallback - Callback on success
 * @param {function} failureCallback - Callback on failure
 */
export const getDashboardFiltersAction = ({
  dashboardId,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_DASHBOARD_FILTERS_REQUEST });

      const { response, error } = await getDashboardFilters(dashboardId);

      // Backend returns { status, success, data } — `data` is null when there are
      // no saved filters (this used to be a 404). Treat that case as "no filters".
      const filterDoc = response?.data?.data ?? null;

      // Handle successful response with data
      if (response?.data && filterDoc) {
        dispatch({
          type: GET_DASHBOARD_FILTERS_SUCCESS,
          payload: {
            dashboardId,
            data: response.data,
          },
        });
        successCallback?.(response.data);
      } 
      // Handle 404 - no saved filters
      else if (response?.status === 404 || error?.response?.status === 404) {
        dispatch({
          type: GET_DASHBOARD_FILTERS_FAILURE,
          payload: "No saved filters found",
        });
        successCallback?.(null);
      }
      // Handle other error responses
      else if (error) {
        dispatch({
          type: GET_DASHBOARD_FILTERS_FAILURE,
          payload: error?.message || "Failed to fetch filters",
        });
        failureCallback?.(error?.message || "Failed to fetch filters");
      }
      // Handle empty response
      else {
        dispatch({
          type: GET_DASHBOARD_FILTERS_FAILURE,
          payload: "No saved filters found",
        });
        successCallback?.(null);
      }
    } catch (err) {
      console.error("❌ Exception in getDashboardFiltersAction:", err);
      dispatch({
        type: GET_DASHBOARD_FILTERS_FAILURE,
        payload: err?.message || "An error occurred",
      });
      failureCallback?.(err?.message || "An error occurred");
    }
  };
};

/**
 * Delete dashboard filters action
 * @param {string} dashboardId - Dashboard identifier
 * @param {function} successCallback - Callback on success
 * @param {function} failureCallback - Callback on failure
 */
export const deleteDashboardFiltersAction = ({
  dashboardId,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      dispatch({ type: DELETE_DASHBOARD_FILTERS_REQUEST });

      const { response, error } = await deleteDashboardFilters(dashboardId);

      if (response?.status === 200) {
        dispatch({
          type: DELETE_DASHBOARD_FILTERS_SUCCESS,
          payload: {
            dashboardId,
            data: response?.data,
          },
        });
        successCallback?.(response?.data);
      } else {
        dispatch({
          type: DELETE_DASHBOARD_FILTERS_FAILURE,
          payload: error?.message || "Failed to delete filters",
        });
        failureCallback?.(error?.message || "Failed to delete filters");
      }
    } catch (err) {
      dispatch({
        type: DELETE_DASHBOARD_FILTERS_FAILURE,
        payload: err?.message || "An error occurred",
      });
      failureCallback?.(err?.message || "An error occurred");
    }
  };
};

/**
 * Update dashboard filters locally in redux (no API call)
 * @param {string} dashboardId - Dashboard identifier
 * @param {object} filters - New filters object
 */
export const updateDashboardFiltersAction = ({ dashboardId, filters }) => {
  return {
    type: UPDATE_DASHBOARD_FILTERS,
    payload: {
      dashboardId,
      data: filters,
    },
  };
};